<template>
  <svg
    v-if="icon === 'tel'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5672 3.04648L12.6951 1.17617C12.5631 1.04353 12.4061 0.938294 12.2332 0.866499C12.0604 0.794704 11.8751 0.757768 11.6879 0.757813C11.3064 0.757813 10.9479 0.907227 10.6789 1.17617L8.66445 3.19062C8.53182 3.32268 8.42658 3.47965 8.35478 3.6525C8.28299 3.82535 8.24605 4.01068 8.2461 4.19785C8.2461 4.5793 8.39551 4.93789 8.66445 5.20684L10.1375 6.67988C9.7927 7.43989 9.3133 8.13129 8.72246 8.7207C8.13311 9.31298 7.44177 9.79412 6.68164 10.141L5.2086 8.66797C5.07654 8.53533 4.91957 8.43009 4.74672 8.3583C4.57387 8.2865 4.38854 8.24956 4.20137 8.24961C3.81992 8.24961 3.46133 8.39902 3.19238 8.66797L1.17617 10.6807C1.04337 10.813 0.938042 10.9702 0.866243 11.1434C0.794445 11.3165 0.757595 11.5022 0.757813 11.6896C0.757813 12.0711 0.907228 12.4297 1.17617 12.6986L3.04473 14.5672C3.47363 14.9979 4.06602 15.2422 4.67422 15.2422C4.80254 15.2422 4.92559 15.2316 5.04688 15.2105C7.41641 14.8203 9.7666 13.56 11.6633 11.665C13.5582 9.77188 14.8168 7.42344 15.2123 5.04688C15.3318 4.3209 15.091 3.57383 14.5672 3.04648Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'mail'"
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2 3.6358V10.0501C15.2 10.6468 14.963 11.2191 14.541 11.6411C14.1191 12.063 13.5468 12.3001 12.95 12.3001H3.05005C2.45331 12.3001 1.88102 12.063 1.45906 11.6411C1.0371 11.2191 0.800049 10.6468 0.800049 10.0501V3.6358L7.77145 7.738C7.84071 7.77884 7.91964 7.80039 8.00005 7.80039C8.08045 7.80039 8.15939 7.77884 8.22865 7.738L15.2 3.6358ZM12.95 0.600098C13.5037 0.600011 14.0379 0.804044 14.4505 1.17316C14.8632 1.54228 15.1252 2.05057 15.1865 2.6008L8.00005 6.8281L0.813549 2.6008C0.874891 2.05057 1.13694 1.54228 1.54956 1.17316C1.96219 0.804044 2.49642 0.600011 3.05005 0.600098H12.95Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'map'"
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 18C5.73694 16.9226 4.56619 15.7415 3.5 14.469C1.9 12.558 8.78894e-07 9.71197 8.78894e-07 6.99997C-0.00069302 5.61493 0.409509 4.26082 1.17869 3.109C1.94788 1.95718 3.04147 1.05943 4.32107 0.529368C5.60067 -0.000693321 7.00875 -0.13924 8.36712 0.131262C9.72548 0.401763 10.9731 1.06915 11.952 2.04897C12.6038 2.69783 13.1203 3.46951 13.4719 4.31934C13.8234 5.16918 14.0029 6.0803 14 6.99997C14 9.71197 12.1 12.558 10.5 14.469C9.4338 15.7415 8.26306 16.9226 7 18ZM7 3.99997C6.20435 3.99997 5.44129 4.31604 4.87868 4.87865C4.31607 5.44126 4 6.20432 4 6.99997C4 7.79562 4.31607 8.55868 4.87868 9.12129C5.44129 9.6839 6.20435 9.99997 7 9.99997C7.79565 9.99997 8.55871 9.6839 9.12132 9.12129C9.68393 8.55868 10 7.79562 10 6.99997C10 6.20432 9.68393 5.44126 9.12132 4.87865C8.55871 4.31604 7.79565 3.99997 7 3.99997Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'iconsButton',
  props: {
    icon: String,
    color: {
      type: String,
      default: '#F2F2F2',
    },
    width: {
      type: [Number, String],
      default: null,
    },
    height: {
      type: [Number, String],
      default: null,
    },
  },
}
</script>

<style scoped></style>
